import { VFC } from 'react';

import ParamLabel from 'dashboard/components/WorkflowControlPanel/ParamLabel';
import { WorkflowActionSendSmsV1 } from 'dashboard/models/workflow-version';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface ActionOutputSendSmsV1Props {
  params: WorkflowActionSendSmsV1['params'];
}

const ActionOutputSendSmsV1: VFC<ActionOutputSendSmsV1Props> = ({ params }) => {
  return (
    <>
      <ParamLabel labelText='To' />
      <Paragraph data-test='action-output-send-sms-v1__recipient'>{params['recipient']}</Paragraph>
      <Spacer height={2} />
      <ParamLabel labelText='Message' />
      <Paragraph data-test='action-output-send-sms-v1__message'>{params['message']}</Paragraph>
    </>
  );
};

export default ActionOutputSendSmsV1;
